import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

let gtmInstalled = false;

@Injectable({ providedIn: 'root' })
export class GoogleTagManagerService {
  constructor() {
    if (environment.thirdPartyConfigs.googleTagManagerEnabled) {
      this.loadGtm();
    } else {
      console.warn('Google Tag Manager is disabled');
    }
  }

  /**
   * Load the Pendo Tracking (via dynamic script)
   */
  loadGtm() {
    if (!gtmInstalled && environment.googleTagManagerId) {
      gtmInstalled = true; // only try to install it once
      // load after the page's first script element
      const ref = window.document.getElementsByTagName('script')[0];
      const headScript = window.document.createElement('script');
      headScript.text = `
        //<!-- Google Tag Manager -->
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${environment.googleTagManagerId}');
        //<!-- End Google Tag Manager -->
      `;

      ref.parentNode.insertBefore(headScript, ref);
    }
  }
}
